export default "assets/350b7e43e8fdd461fb95513c836fc551.png";